import type { ReactNode } from 'react'
import useModuleHeader from './useModuleHeader'
import { RailHeader, StyledModuleHeader } from './styled-components'

interface ModuleHeaderProps {
  clickable?: boolean
  onClick?: () => void
  children: ReactNode
}

const ModuleHeader = ({ clickable = false, onClick, children }: ModuleHeaderProps) => {
  const { rail, railChild } = useModuleHeader(children)

  if (rail) {
    return <RailHeader>{railChild}</RailHeader>
  }

  return (
    <StyledModuleHeader $clickable={clickable} onClick={onClick}>
      {children}
    </StyledModuleHeader>
  )
}

export default ModuleHeader
